import { Supervisor } from "../../permissions"

export const OldMenuPermissions: { [key: string]: string } = {
    monitoring: Supervisor,
    positions: Supervisor,
    users: Supervisor
}
